import ChoixBeneficiareVitale from './components/ChoixBeneficiareVitale.vue'
import AcquisDroitIntegre from './components/AcquisDroitIntegre.vue'
import LireCarteVitale from './components/LireCarteVitale.vue'
import TransCAM from './components/TransCam/TransCAM.vue'
import Lots from './components/Lot.vue'
import Gestion from './components/Gestion.vue'
import Envois from './components/Envois.vue'
import Vitale from './components/LireCarteVitale.vue'
import Patient from './components/Patient.vue'
import Fse from './components/Fse.vue'
import Parametre from './components/Altyse/Parametre/Parametre.vue'
//import Paramètres from './components/Envois.vue'/transcam/fse
import Règlement from './components/Règlement.vue'
import TiersPayants from './components/TiersPayants.vue'
import Erreur from './components/Erreur.vue'



import config from './config.js'
import Connexion from './script/Connexion'

const TransCamRoutes = [
    
    {
        name: 'Fse',
        path: config.urlFrontEnd + '/transcam/Fse',
        component: Fse,
        props: true
    },
    {
        name: 'Gestion',
        path: config.urlFrontEnd + '/transcam/Gestion',
        component: Gestion,
        props: true
    },
    {
        name: 'Lots',
        path: config.urlFrontEnd + '/transcam/Lots',
        component: Lots,
        props: true
    },
    {
        name: 'Vitale',
        path: config.urlFrontEnd + '/transcam/LireCarteVitale',
        component: Vitale,
        props: false
    },
    {
        name: 'TransCAM',
        path: config.urlFrontEnd + '/transcam',
        component: TransCAM,
        props: true,
    },
    {
        name: 'ParametreWithComponent',
        path: '/transCam/parametre/:parametreComposant',
        component: Parametre,
        props: true
    },
    {
        name: 'Patient',
        path: config.urlFrontEnd + '/transcam/Patient',
        component: Patient,
        props: true
    }
    // Other sign-in related routes
];

export default TransCamRoutes
